import { api } from '../utils/apiClient';

export const journeyService = {
  async getAll(params) {
    return api.get('/journeys', params);
  },

  // Listing table needs meta (total, statusCounts) alongside the rows.
  async getAllWithMeta(params) {
    return api.getWithMeta('/journeys', params);
  },

  async getById(id) {
    return api.get('/journeys/' + id);
  },

  async create(journey) {
    return api.post('/journeys', journey);
  },

  async update(id, patch) {
    return api.put('/journeys/' + id, patch);
  },

  async remove(id) {
    return api.del('/journeys/' + id);
  },

  // Freezes the current draft into an immutable version and promotes it live.
  async publish(id) {
    return api.put('/journeys/' + id + '/publish');
  },

  async versions(id) {
    return api.get('/journeys/' + id + '/versions');
  },

  // Per-node Live View report. params: { version, from, to } (all optional).
  async report(id, params) {
    return api.get('/journeys/' + id + '/report', params);
  },

  async activate(id) {
    return api.put('/journeys/' + id + '/activate');
  },

  async pause(id) {
    return api.put('/journeys/' + id + '/pause');
  },

  // Stop new admissions but let in-flight trips finish under their existing rules.
  async sunset(id) {
    return api.put('/journeys/' + id + '/sunset');
  },

  async stop(id) {
    return api.put('/journeys/' + id + '/stop');
  },

  async stats(id) {
    return api.get('/journeys/' + id + '/stats');
  },
};
